export function isStringArrayUpdated(
  oldArray: string[],
  newArray: string[]
): boolean {
  // Check if arrays have different lengths
  if (oldArray.length !== newArray.length) {
    return true;
  }

  // Compare each element
  for (let i = 0; i < oldArray.length; i++) {
    if (oldArray[i] !== newArray[i]) {
      return true;
    }
  }

  return false;
}

export const findObjectFromArrayByFieldAndValue = (
  array: { [key: string]: any }[],
  key: string,
  value: string
): any | null => {
  const foundObject = array.find((obj) => obj[key] === value);
  return foundObject || null;
};